import { createContext, FunctionComponent } from 'preact';
import { useContext, useMemo } from 'preact/hooks';
import type { Locale } from '@schibsted-svp/web-player';

export interface LocaleContextProps {
  locale: Exclude<Locale, 'en'>;
}

const LocaleContext = createContext<LocaleContextProps>({ locale: 'no' });

export interface LocaleProviderProps {
  locale?: Exclude<Locale, 'en'>;
}

const LocaleProvider: FunctionComponent<LocaleProviderProps> = ({
  children,
  locale = 'no',
}) => {
  const state = useMemo(() => ({ locale }), [locale]);

  return (
    <LocaleContext.Provider value={state}>{children}</LocaleContext.Provider>
  );
};

export const useLocaleContext = () => {
  const locale = useContext(LocaleContext);

  if (process.env.NODE_ENV !== 'production' && !locale) {
    console.warn(
      'Locale context is undefined, please verify you are calling useLocaleContext() as child of a <LocaleProvider> component.'
    );
  }

  return locale;
};

export default LocaleProvider;
